import BankidVerificationUI from '../ui/bank-id-recovery-ui';

export default function () {
    BankidVerificationUI.attachTo(document);
}
